'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Raf = require('./Raf');

var _Raf2 = _interopRequireDefault(_Raf);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _in2 = {}; // components subscribed to in()
var _out = {}; // components subscribed to out()
var _always = {}; // components subscribed to always()
var _isRunning = false;
var _prefix = 'ONS_';
var _lastID = 1; // subscribers are assigned an id based on the previous id
var _raf_id = null;
var _scrollPos = 0;
var _lastScrollPos = 0;
var _innerHeight = window.innerHeight;
var body = document.body;
var _timer = void 0;

/**
 * OnScreen Component
 *
 *  provides callbacks for when an element enters or leaves view on scroll
 *  @class
 */

var OnScreen = function () {

  /*
   * Constructor
   */
  function OnScreen() {
    _classCallCheck(this, OnScreen);

    this.scrollHandler = this._onScroll.bind(this);
    window.addEventListener('scroll', this.scrollHandler, false);
  }

  /**
   * Subscribe elements to in() callback (Element is in view)
   * @param  {HTMLElement}    element   DOM element that we want to watch
   * @param  {Function}       callback  Callback function that is called when an element is in view
   * @param  {boolean}        full      Indicates wether the element should be completely in view
   * @return {String}                   Return client id. Should be used to unsubscribe the element
   */


  _createClass(OnScreen, [{
    key: 'in',
    value: function _in(element, callback, full) {
      if (typeof callback !== 'function') return;

      var id = _prefix + _lastID++;
      _in2[id] = {
        el: element,
        cb: callback,
        full: full
      };
      this.start();
      return id;
    }

    /**
     * Subscribe elements to out() callback (Element is leaving view)
     * @param  {HTMLElement}    element   DOM element that we want to watch
     * @param  {Function}       callback  Callback function that is called when an element is leaving view
     * @return {String}                   Return client id. Should be used to unsubscribe the element
     */

  }, {
    key: 'out',
    value: function out(element, callback) {
      if (typeof callback !== 'function') return;
      var id = _prefix + _lastID++;
      _out[id] = {
        el: element,
        cb: callback
      };
      this.start();
      return id;
    }

    /**
     * Subscribe elements to always() callback (Element is either in view or out of view)
     * @param  {HTMLElement}    element   DOM element that we want to watch
     * @param  {Function}       callback  Callback function that is called on scroll
     * @return {String}                   Return client id. Should be used to unsubscribe the element
     */

  }, {
    key: 'always',
    value: function always(callback) {
      if (typeof callback !== 'function') return;
      var id = _prefix + _lastID++;
      _always[id] = {
        cb: callback
      };
      this.start();
      return id;
    }

    /**
     * Removes element from subscribers list
     * @param  {String} id Client id received on subscription
     */

  }, {
    key: 'unsubscribe',
    value: function unsubscribe(id) {
      if (_in2[id]) {
        delete _in2[id];
      } else if (_out[id]) {
        delete _out[id];
      } else if (_always[id]) {
        delete _always[id];
      }

      if (_in2.length === 0 && _out.length === 0 && _always.length === 0) {
        this.stop();
      }
    }

    /**
     * Start tick to update scroll position and check subscribers
     */

  }, {
    key: 'start',
    value: function start() {
      if (_in2.length < 1 && _out.length < 1 && _always.length < 1 || _isRunning) {
        return; // no elements or already running -> don"t do anything
      }
      _raf_id = _Raf2.default.subscribe(this._tick.bind(this));
      _isRunning = true;
      this._tick();
    }

    /**
     * Stop update tick
     */

  }, {
    key: 'stop',
    value: function stop() {
      _Raf2.default.unsubscribe(_raf_id);
      window.removeEventListener('scroll', this.scrollHandler);
      _isRunning = false;
    }

    /*
     * Update subscribers on tick
     * @param  {boolean} force force tick even if scroll position has not changed
     */

  }, {
    key: '_tick',
    value: function _tick(force) {
      var _this = this;

      if (_scrollPos === _lastScrollPos && force !== true) {
        return;
      }

      _innerHeight = window.innerHeight;
      _reactDom2.default.unstable_batchedUpdates(function () {
        _this._updateSubscribers(_scrollPos);
      });

      _lastScrollPos = _scrollPos;
    }

    /*
     * Scroll event callback
     */

  }, {
    key: '_onScroll',
    value: function _onScroll() {
      clearTimeout(_timer);
      if (body.className.indexOf('disable-hover') === -1) {
        //  remove pointer events on scroll for optimisation (make sure class is added in CSS)
        body.className = body.className + ' disable-hover';
      }

      _timer = setTimeout(function () {
        body.className = body.className.replace(' disable-hover', '');
      }, 250);

      _scrollPos = this._scrollPosition();
    }

    /*
     * Update all subscriber according to scroll position
     * @param  {number} scrollPos Current scroll position
     */

  }, {
    key: '_updateSubscribers',
    value: function _updateSubscribers(scrollPos) {
      for (var id in _in2) {
        var perc = this._isOnScreen(_in2[id].el, _in2[id].full);
        if (perc !== false) {
          _in2[id].cb(perc);
        }
      }
      for (var _id in _out) {
        if (this._isOnScreen(_out[_id].el, false) === false) {
          _out[_id].cb();
        }
      }
      for (var _id2 in _always) {
        _always[_id2].cb(scrollPos);
      }
    }

    /*
     * Get current scroll position
     */

  }, {
    key: '_scrollPosition',
    value: function _scrollPosition() {
      return Math.max(document.documentElement.scrollTop, body.scrollTop);
    }

    /*
     * Check wether an element is on screen
     * @param  {HTMLElement}  element  DOM element we want to test
     * @param  {boolean}      full     Indicates wether we want the DOM element to be completely visible
     * @return {Boolean}      Returns if a DOM element is on screen
     */

  }, {
    key: '_isOnScreen',
    value: function _isOnScreen(element, full) {
      if (element === undefined) {
        return false;
      }

      var bounds = element.getBoundingClientRect();
      var is = bounds.top < _innerHeight && bounds.bottom > 0;

      if (!is) {
        return false;
      }
      if (!full) {
        return true;
      }

      var x = bounds.top; // + ~~(bounds.height * 0.5)
      var half = ~~(_innerHeight * 0.5);
      var diff = x; // half - x

      return diff / _innerHeight;
    }
  }]);

  return OnScreen;
}();

var single = new OnScreen(); // nice little Singleton
exports.default = single;


//////////////////
// WEBPACK FOOTER
// ./src/lib/OnScreen.js
// module id = 33
// module chunks = 1